import logo from './logo.svg';
import './App.css';
import Portfolio from './Portfolio/Portfolio';

function App() {
  return (
    <div className="App">
    <Portfolio/>
    </div>
  );
}

export default App;
